// NOTE: this just acts as a shim above the RegionalEmbed that allows us to
// hard code/restrict some props we do this by maintaining our own reducer/data
// loading, and calling RegionalEmbed directly rather than the connevted
// version
import React from 'react'
import { connect } from 'react-redux'
import p from 'prop-types'
import { loadRSO, loadGeoJSON } from 'lib/api/embeds/regional'
import { RegionalEmbed } from '../RegionalEmbed'

export class PublicEmbed extends React.PureComponent {
  static propTypes = {
    id: p.oneOfType([p.number, p.string]).isRequired,
    metricUnits: p.string,
    showUnitConversion: p.string,
    boundingBox: p.string,
    hot: p.string,
    useClusters: p.string,
    onlyShowClusters: p.string,
    scrollWheelZoom: p.string,
    hideFeatureLink: p.string,
    showDetailsOnHover: p.string,
    showStartMarkers: p.string,
    selectedColor: p.string
  }

  render () {
    return (
      <RegionalEmbed overlay='esriTopo' noLinks zoomLimit={10} {...this.props} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { publicEmbed } = state
  const embedSettings = publicEmbed.getIn(['embedData', 'embedSettings'])

  return {
    rso: publicEmbed.get('embedData'),
    geoJSON: publicEmbed.get('geoJSON'),

    // Default to ownProps (which means url params), fall back to embedSettings
    boundingBox: ownProps.boundingBox || embedSettings.get('boundingBox'),
    metricUnits: ownProps.metricUnits || embedSettings.get('metricUnits')
  }
}

const mapDispatchToProps = {
  loadRSO: loadRSO,
  loadGeoJSON: loadGeoJSON
}

export const PublicEmbedContainer = connect(mapStateToProps, mapDispatchToProps)(PublicEmbed)
